import { Button, Classes, ControlGroup, MenuItem, Position } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import PropTypes from 'prop-types';
import React from 'react';
import get from 'utils/get';
import styled from 'styled-components';

const ButtonText = styled.span`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const getGenderIcon = gender => {
  switch (gender) {
    case 'f':
    case 'female':
      return <img alt="female" src="/static/img/woman-20.png" />;
    case 'm':
    case 'male':
      return <img alt="male" src="/static/img/man-20.png" />;
    default:
      return <img alt="" src="/static/img/question-mark-20.png" />;
  }
};

const PersonSelect = ({
  className,
  disabled,
  fill,
  onChange,
  persons,
  selectedPerson,
  placeholder,
  labelKey,
}) => {
  const itemPredicate = (query, person) => {
    return person[labelKey].toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };

  const renderOption = (person, { handleClick, modifiers }) => {
    const { birth, death, gender } = person;
    const birthYear = birth == null ? undefined : `${new Date(birth).getFullYear()}`;
    const deathYear = death == null ? undefined : `${new Date(death).getFullYear()}`;
    const label = [birthYear, deathYear].filter(value => value != null).join(' – ');
    return (
      <MenuItem
        active={modifiers.active}
        disabled={modifiers.disabled}
        key={person.id}
        icon={getGenderIcon(gender)}
        label={label}
        onClick={handleClick}
        text={person[labelKey]}
      />
    );
  };

  return (
    <ControlGroup className={className} fill={fill}>
      <Select
        activeItem={selectedPerson}
        disabled={disabled}
        className={fill ? Classes.FILL : undefined}
        itemPredicate={itemPredicate}
        itemRenderer={renderOption}
        items={persons}
        noResults={<MenuItem disabled text="No results." />}
        onItemSelect={onChange}
        popoverProps={{ minimal: false, position: Position.BOTTOM_LEFT, targetTagName: 'div' }}
      >
        <Button
          disabled={disabled}
          fill={fill}
          icon="person"
          rightIcon="caret-down"
          text={<ButtonText>{get(selectedPerson, labelKey, placeholder)}</ButtonText>}
        />
      </Select>
      {selectedPerson && (
        <Button disabled={disabled} onClick={() => onChange(undefined)} icon="cross" />
      )}
    </ControlGroup>
  );
};

PersonSelect.defaultProps = {
  className: undefined,
  disabled: false,
  fill: false,
  onChange: () => {},
  persons: [],
  selectedPerson: undefined,
  placeholder: 'Select person',
  labelKey: 'name',
};

PersonSelect.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fill: PropTypes.bool,
  onChange: PropTypes.func,
  persons: PropTypes.arrayOf(PropTypes.object),
  selectedPerson: PropTypes.object,
  placeholder: PropTypes.string,
  labelKey: PropTypes.string,
};

export default PersonSelect;
